import React from "react";
import { Spinner } from "react-bootstrap";

const Loading = () => {
  return (
    <>
      <div style={{ justifyContent: "center", textAlign: "center",marginTop:"10px" }}>
        <Spinner animation="border" variant="success" />
      </div>
    </>
  );
};

export default Loading;
